import { CardHeader } from "reactstrap"
import styled from "styled-components"

export const StyledH3 = styled.h3.attrs(() => ({
    className: 'pb-2 mb-4 border-bottom  font-bold text-2xl'
}))``

export const StyledCardHeader = styled(CardHeader).attrs(() => ({
    className: 'h5 card-header bg-transparent border-0 pb-0',

}))`
font-family: "Verdana";
color: var(-- ${props => props.titleColor});
`